export default {
	name: 'SubscriptionsView'
}